import React, { useEffect } from "react";
import TopNavbar from "../components/Nav/TopNavbar";
import Header from "../components/Sections/Header";
import Projects from "../components/Sections/Projects";
import Contact from "../components/Sections/Contact";
import Footer from "../components/Sections/Footer"
import SEO from "../components/SEO";
import { useLocation } from "react-router-dom";
import { scroller } from "react-scroll";

export default function Landing() {
  const location = useLocation();
  useEffect(() => {
    const section = location.state?.scrollTo;
    if (section) {
      setTimeout(() => {
        scroller.scrollTo(section, {
          duration: 600,
          smooth: true,
          offset: -80,
        });

        try {
          window.history.replaceState({}, document.title, window.location.pathname + window.location.search);
        } catch (e) {
        }
      }, 50);
    }
  }, [location]);
  return (
    <>
      <SEO
        title="Sare Auctioneers | Property Auctions & Auctioneering Services in Kenya"
        description="Sare Auctioneers is a licensed Class B auctioneering firm in Kenya providing property auctions, public auctions, debt collection, repossessions, distress for rent, court process serving, private investigations and realization of charged securities."
        structuredData={{
          "@context": "https://schema.org",
          "@type": "ProfessionalService",
          name: "Sare Auctioneers",
          description:
            "Sare Auctioneers is a licensed Class B auctioneering firm in Kenya providing property auctions, public auctions, debt collection, repossessions, distress for rent, court process serving, private investigations and realization of charged securities.",
          url:
            typeof window !== "undefined"
              ? window.location.origin
              : "https://sareauctioneers.co.ke",

          areaServed: {
            "@type": "Country",
            name: "Kenya",
          },

          serviceType: [
            "Property Auctions",
            "Public Auctions",
            "Debt Collections",
            "Court Process Service",
            "Repossessions of Chattels and Mortgage",
            "Distress of Rent",
            "Realisation of Charged Securities",
            "Private Investigations",
            "Court Warrants Executions",
          ],
        }}
      />
      <TopNavbar />
      <Header />
      {/* <Services />   */}
      <Projects />
      {/* <Blog /> */}
      {/* <Pricing /> */}
      <Contact standalone={false} />
      <Footer />
    </>
  );
}